import { Text } from '@cuemath/comps';
import styled from 'styled-components';
import COLORS from 'constants/colors';

const ApplicantProfileHeading = styled(Text)`
  background-color: ${COLORS.HAWKESBLUE};
  border: 1px solid ${COLORS.SCIENCEBLUE};
  text-align: center;
  padding: 6px;
  margin: 20px 10px 0 10px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
`;

const ApplicantProfileInfoWrapper = styled.div`
  border: 1px solid ${COLORS.SILVERCHALICE};
  border-top-color: transparent;
  margin: 0 10px;
  padding: 10px 10px 30px 10px;
`;

const ApplicantProfileLabelWrapper = styled(Text)`
  margin: 5px 0;
`;

const ApplicantProfileValueWrapper = styled(Text)`
  border-bottom: 1px solid black;
  word-break: break-all;
  user-select: ${({ disableUserSelect }) => (disableUserSelect ? 'none' : 'auto')};
`;

const ApplicantProfileLinkWrapper = styled(Text)`
  color: ${COLORS.BOSTON_BLUE};
  text-decoration: none;
  cursor: pointer;
`;

export {
  ApplicantProfileInfoWrapper,
  ApplicantProfileHeading,
  ApplicantProfileValueWrapper,
  ApplicantProfileLinkWrapper,
  ApplicantProfileLabelWrapper,
};
